import React from 'react'

import './PathMap.css'

import { useState, useEffect } from 'react'
import { BackButton } from '@/components/layout/NavBar'
import { Services } from '@/services/services'
import { useParams } from 'react-router-dom'

import { CurrentSession } from '@/services/repository/session'
import { MainPageLayout } from '@/components/layout/MainLayout'

import { useTranslations } from '@/hooks/useTranslations'
import { PathMapComponent } from '@/components/Map/PathMap'

import { MachinePath } from './Common'
import { Machine } from '@/services/model/machine'

export const CommunalMachinePathMap = ({ services, session }: { services: Services, session: CurrentSession }) => {
  const machineId = useParams().mid
  const translates = useTranslations(services, session)
  const [machine, setMachine] = useState<Machine>()

  useEffect(() => {
    setMachine(undefined)
    fetch(`/api/communal/machines/byid/${machineId}`).then((response) => {
      return response.json()
    }).then((data) => {
      setMachine(data)
    })
  }, [machineId])

  if (!machine || !translates) {
    return <div className='spinner'></div>
  }

  return <MainPageLayout pageName='machine-pathmap' services={services} translates={translates} session={session}
    path={[...MachinePath({ session, translates, machine }), {
      title: translates.for(`page.machine-pathmap.title`)
    }]}
    navbarLeft={<BackButton services={services} translates={session.translates} />}>
    <PathMapComponent fetchUrl={`/api/communal/machines/byid/${machineId}/path/map`} services={services} session={session} />
  </MainPageLayout>
}
